/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const getValueFromObject = (obj: object, key: string): any => {
    return key.split(".").reduce((obj, key) => obj?.[key] ?? "", obj)
}


// WEBPACK FOOTER //
// ./src/utils/object/utils.ts